"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.Carousel = void 0;
var tslib_1 = require("tslib");
var lodash_1 = require("lodash");
var mobx_1 = require("mobx");
var mithril_1 = require("../../mithril");
var image_button_1 = require("../button/image.button");
var icons_1 = require("../icon/icons");
var mithril_component_1 = require("../mithril.component");
var theme_1 = require("../theme");
var theme_palette_1 = require("../theme.palette");
var CSS = {
    container: 'c-Carousel',
    constraint: 'c-Carousel__Constraint',
    controls: 'c-Carousel__Controls',
    track: 'c-Carousel__Track',
    center: 'c-Carousel__Center',
    image: 'c-Carousel__Image',
    dot: 'c-Carousel__Dot',
    highlighted: 'c-Carousel__Dot--highlighted'
};
var Style = (_a = {},
    _a[CSS.container] = {
        position: 'relative',
        width: '100%',
        height: '100%'
    },
    _a[CSS.controls] = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        zIndex: 1,
        pointerEvents: 'none'
    },
    _a["".concat(CSS.controls, " a")] = {
        pointerEvents: 'all',
        backgroundColor: theme_1.DefaultTheme.background.mediumGrey,
        color: "rgb(".concat(theme_palette_1.WHITE, ")"),
        '&:hover': {
            backgroundColor: theme_1.DefaultTheme.background.darkGrey
        },
        '&:disabled': {
            backgroundColor: theme_1.DefaultTheme.background.mediumGrey,
            color: "rgb(".concat(theme_palette_1.WHITE, ")"),
            opacity: '0.4'
        }
    },
    _a[CSS.constraint] = {
        overflow: 'hidden',
        position: 'relative',
        height: 'calc(100% - 18px)',
        paddingBottom: '6px'
    },
    _a[CSS.track] = {
        height: '100%',
        transition: '150ms ease',
        display: 'flex',
        flexWrap: 'nowrap'
    },
    _a[CSS.center] = {
        width: '100%',
        display: 'flex',
        justifyContent: 'center'
    },
    _a[CSS.image] = {
        height: '100%'
    },
    _a[CSS.dot] = {
        width: '12px',
        height: '12px',
        borderRadius: '6px',
        background: theme_1.DefaultTheme.background.lightGrey,
        cursor: 'pointer',
        border: 0,
        margin: '0 2px'
    },
    _a[CSS.highlighted] = {
        background: theme_1.DefaultTheme.background.mediumGrey
    },
    _a);
(0, theme_1.addStyles)(Style);
var Carousel = /** @class */ (function (_super) {
    tslib_1.__extends(Carousel, _super);
    function Carousel(_a) {
        var _b = _a.index, index = _b === void 0 ? 0 : _b, _c = _a.slides, slides = _c === void 0 ? [] : _c, _d = _a.showControls, showControls = _d === void 0 ? true : _d, onSlideChange = _a.onSlideChange;
        var _this = _super.call(this) || this;
        _this.currentIndex = (0, lodash_1.clamp)(index, 0, slides.length - 1);
        _this.slides = slides;
        _this.showControls = showControls;
        _this.onSlideChange = onSlideChange;
        return _this;
    }
    Carousel.prototype.goTo = function (index) {
        var _a;
        this.currentIndex = (0, lodash_1.clamp)(index, 0, this.slides.length - 1);
        (_a = this.onSlideChange) === null || _a === void 0 ? void 0 : _a.call(this, this.currentIndex);
    };
    Object.defineProperty(Carousel.prototype, "scalarSlideWidth", {
        get: function () {
            // avoid NaN from 0 denominator
            if (this.slides.length > 0) {
                return 100 / this.slides.length;
            }
            return 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "controls", {
        get: function () {
            var _this = this;
            if (this.showControls) {
                return (0, mithril_1.m)('div', {
                    className: CSS.controls
                }, [
                    image_button_1.ImageButton.view(icons_1.MaterialIcon.NAVIGATE_PREV, {
                        onclick: function () { return _this.goTo(_this.currentIndex - 1); },
                        disabled: this.currentIndex === 0
                    }),
                    image_button_1.ImageButton.view(icons_1.MaterialIcon.NAVIGATE_NEXT, {
                        onclick: function () { return _this.goTo(_this.currentIndex + 1); },
                        disabled: this.currentIndex === this.slides.length - 1 || !this.slides.length
                    })
                ]);
            }
            return null;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "dots", {
        get: function () {
            var _this = this;
            return (0, mithril_1.m)('div', {
                className: CSS.center
            }, this.slides.map(function (_, i) { return ((0, mithril_1.m)('button', {
                className: "".concat(CSS.dot, " ").concat(i === _this.currentIndex && CSS.highlighted),
                onclick: function () { return _this.goTo(i); }
            })); }));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Carousel.prototype, "nodes", {
        get: function () {
            return (0, mithril_1.m)('div', {
                className: CSS.container
            }, [
                this.controls,
                (0, mithril_1.m)('div', {
                    className: CSS.constraint
                }, (0, mithril_1.m)('div', {
                    className: CSS.track,
                    style: {
                        width: "".concat(100 * this.slides.length, "%"),
                        transform: "translateX(-".concat(this.currentIndex * this.scalarSlideWidth, "%)")
                    }
                }, this.slides.map(function (slide) {
                    return (0, mithril_1.m)('div', {
                        className: "".concat(CSS.center, " ").concat(CSS.image)
                    }, slide);
                }))),
                this.dots
            ]);
        },
        enumerable: false,
        configurable: true
    });
    tslib_1.__decorate([
        mobx_1.observable
    ], Carousel.prototype, "currentIndex", void 0);
    tslib_1.__decorate([
        mobx_1.action
    ], Carousel.prototype, "goTo", null);
    return Carousel;
}(mithril_component_1.IMithrilStateComponent));
exports.Carousel = Carousel;
//# sourceMappingURL=carousel.component.js.map